var _style, _g, _g2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClever(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    id: "katman_1",
    x: "0px",
    y: "0px",
    viewBox: "265.559 38.477 271.884 272.536",
    style: {
      enableBackground: "new 0 0 800 600"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2367AC;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "st0",
    d: "M360.7,39.4h81.7c27.1,0,40.6,0,55.2,4.6c15.9,5.8,28.5,18.3,34.3,34.3 c4.6,14.6,4.6,28.1,4.6,55.2v81.7c0,27.1,0,40.6-4.6,55.2c-5.8,15.9-18.3,28.5-34.3,34.3c-14.6,4.6-28.1,4.6-55.2,4.6h-81.7 c-27.1,0-40.6,0-55.2-4.6c-15.9-5.8-28.5-18.3-34.3-34.3c-4.6-14.6-4.6-28.1-4.6-55.2v-81.7c0-27.1,0-40.6,4.6-55.2 c5.8-15.9,18.3-28.5,34.3-34.3C320,39.4,333.6,39.4,360.7,39.4L360.7,39.4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    className: "st1",
    d: "M410.3,262.7c-50.4,0-87.9-38.8-87.9-87.8v-0.5c0-48.5,36.7-88.3,89.4-88.3 c32.3,0,51.7,10.7,67.6,26.3l-24,27.6c-13.2-11.9-26.7-19.3-43.8-19.3c-28.9,0-49.7,23.9-49.7,53.2v0.5c0,29.3,20.3,53.7,49.7,53.7 c19.6,0,31.6-7.8,45-20l24,24.2C463,251,443.4,262.7,410.3,262.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4-2",
    className: "st1",
    d: "M410.3,262.7c-50.4,0-87.9-38.8-87.9-87.8v-0.5c0-48.5,36.7-88.3,89.4-88.3 c32.3,0,51.7,10.7,67.6,26.3l-24,27.6c-13.2-11.9-26.7-19.3-43.8-19.3c-28.9,0-49.7,23.9-49.7,53.2v0.5c0,29.3,20.3,53.7,49.7,53.7 c19.6,0,31.6-7.8,45-20l24,24.2C463,251,443.4,262.7,410.3,262.7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 362.8,
    className: "st2",
    width: 622,
    height: 197.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClever);
export default __webpack_public_path__ + "static/media/clever.5a009a5d2a0a89335f37e35ab290edc5.svg";
export { ForwardRef as ReactComponent };